import { faMagnifyingGlass, faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    BoxProps,
    IconButton,
    InputAdornment,
    Box as MuiBox,
    TextField,
} from "@mui/material";
import { styled } from "@mui/system";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { Legend_Z_Index } from "src/const";
import { MapContext } from "src/contexts/map";
import { URL_MAP_VIEW } from "src/router/routes";

const MobileSearchBar = () => {
    const { t } = useTranslation();
    const { filters, updateFilters } = useContext(MapContext);
    const { schema } = useParams<{ schema: string }>();

    const Box = styled(MuiBox)<BoxProps>(({ theme }) => {
        const isLocationMap = location.pathname === `/${schema}${URL_MAP_VIEW}`;

        return {
            zIndex: Legend_Z_Index,
            position: isLocationMap ? "absolute" : "inherit",
            marginTop: theme.spacing(2),
            left: isLocationMap ? theme.spacing(2) : theme.spacing(0),
            backgroundColor: theme.palette.common.white,
            width: "93%",
        };
    });

    const handleClearSearch = () => {
        updateFilters({ ...filters, search: "" });
    };

    return (
        <Box>
            <TextField
                placeholder={t("search")}
                size="small"
                value={filters.search}
                onChange={(e) =>
                    updateFilters({
                        ...filters,
                        search: e.target.value,
                    })
                }
                fullWidth
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <FontAwesomeIcon icon={faMagnifyingGlass} />
                        </InputAdornment>
                    ),
                    endAdornment: filters.search && (
                        <InputAdornment position="end">
                            <IconButton
                                edge="end"
                                onClick={() => handleClearSearch()}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
        </Box>
    );
};

export default MobileSearchBar;
